import { render } from "./Dashboards.vue?vue&type=template&id=3fdb858b"
import script from "./Dashboards.vue?vue&type=script&lang=js"
export * from "./Dashboards.vue?vue&type=script&lang=js"
script.render = render

export default script